



























































































































































































































































































































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Vue, Component, Ref, Watch } from "vue-property-decorator";
import { PanelConfigModule } from "@/store/modules/PanelConfigModule";
import { PanelModule } from "@/store/modules/PanelModule";
import { observePanel, getPanelStatusHistoryRange, getPanelStatusHistoryRangeWithoutEndDate } from "@/data/repository/PanelRepository";
import { Panel, StatusHistory } from "@/data/models/Panel";
import { PanelConfig, getConfigForPanelType } from "@/data/models/PanelConfig";
import router from "@/router/router";
import PanelStatusEntryComponent from "@/components/panel/PanelStatusEntry.vue";
import PanelStatusCardComponent from "@/components/panel/PanelStatusCard.vue";
import ComBoxStatusCardComponent from "@/components/combox/ComBoxStatusCard.vue";
import RunItemComponent from "@/components/panel/RunItem.vue";

import DryingProgressGraphControlComponent from "@/components/panel/DryingProgressGraphControl.vue";

import DryingProgressGraphComponent from "@/components/panel/DryingProgressGraph.vue";
import {
  getProgramChain,
  observeRecentProgramChains,
  observeProgramChainsInTimeRanges,
  observeProgramChain,
} from "@/data/repository/ProgramChainRepository";

import {
  getClientPanelAllAssignments,
  getClientPanelAssignment,
  getClientPanelAssignmentsOfProjectAndSerialNumber,
  getMemberClientPanelAllAssignments,
  getMemberClientPanelAssignmentsOfProjectAndSerialNumber,
} from "@/data/repository/ClientPanelAssignmentRepository";
import {
  getMemberClientPanel,
  getClientPanel,
  getCurrentProjectAssignmentDetails,
} from "@/data/repository/ClientPanelRepository";

import {
  ProgramChain,
  getProjectAssignmentDetailsOfProgramChain,
  isNewDryRunProgramChain,
  createNewDryRunProgramChain,
  createOverviewProgramChain,
  isOverviewProgramChain,
  matchesMinProgramChainDuration,
  filterRunsWithCorrectProgramNumber
} from "@/data/models/ProgramChain";
import {
  isActiveRun,
  RunOverview,
  setProjectAssignmentInfoOfRuns,
} from "@/data/models/RunOverview";
import {
  formatProjectAssignmentDetails,
  getProjectAssignmentDetailsFromClientPanelAssignments,
  ProjectAssignmentDetails,
} from "@/data/models/ProjectAssignmentInfo";
import { 
  DryingProgressChartData,
  extractDryingProgressGraphData,
  prefetchWeatherData,
} from "@/utils/DryingProgressGraphDataExtractor";
// Namespaced on purpose: several of these share a name with this component's own getters, and
// `graphPanel.showAiPredictions(...)` makes it obvious which one is meant.
import * as graphPanel from "@/utils/DryingGraphPanelState";
import {
  getBranchesOfClient,
  getBranchesOfMemberClient,
  getClient,
  getClientId,
  getClientInfo,
  getMemberClientIds,
} from "@/data/repository/ClientRepository";

import InfiniteLoading from "vue-infinite-loading";
import {
  ClientPanelAssignment,
  doesAssignmentIncludeProgramChain,
} from "@/data/models/ClientPanelAssignment";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import {
  didIresDeviceTimeOut,
  getIresDeviceCategoryFromSerialNumber,
  getIresDeviceDisplayName,
  IresDevice,
  IresDeviceCategory,
  isActiveProgramChainOfIresDevice,
  isPoweredOff,
} from "@/data/models/IresDevice";
import { getIresDeviceRecordState, IresDeviceRecordState } from "@/utils/IresDeviceRecordState";
import { formatDateTohDateMonthYearString } from "@/utils/DateHelper";
import { observeComBox } from "@/data/repository/ComBoxRepository";
import { ComBoxModule } from "@/store/modules/ComBoxesModule";
import {
  ComBox,
  ComBoxDeviceState,
  getComBoxState,
  isWaitingForNewProgramChain,
} from "@/data/models/ComBox";
import { TargetSensors, LegendDisplayMode } from "../common/SelectionTable.vue";
import { getBoolean, setBoolean } from "@/utils/SecureLocalStorage";
import DryingInfoItemComponent from "@/components/devices/DryingInfoItem.vue";
import ClientPanel from "@/data/models/ClientPanel";
import IresDeviceDetailContentSelectorComponent from "@/components/devices/IresDeviceDetailContentSelector.vue";
import DryingProgressGraphLegendComponent from "../panel/DryingGraphLegend.vue";
import { createPdfReportForProgramChains } from "@/utils/pdf/PdfCreator";
import { DeviceAssignment } from "@/data/models/PanelAssignment";
import SetPanelOfflineComponent from "../panel/SetPanelOffline.vue";
import PanelControlComponent from "../panel/PanelControl.vue";
import ComBoxControlComponent from "../combox/ComBoxControl.vue";
import RateDryingComponent from "./ratedrying/RateDrying.vue";
import AiPredictionsComponent from "./quality/AiPredictions.vue";
import RenoTimeSeriesComponent from "./quality/RenoTimeSeries.vue";
import DryingTimelineMarkerComponent from "./quality/DryingTimelineMarker.vue";
import { TrendEntry } from "@/data/models/AiPrediction";
import HyDryEventLogListComponent from "./log/HyDryEventLogList.vue";
import { formatProjectNameAndNumber } from "@/data/models/ProjectDetails";
import { DateTime } from "luxon";
import { firestore } from "firebase";
import { IresDeviceAssignment } from "@/data/models/IresDeviceAssignment";
import { getAllAssignmentsOfCurrentClient, getAllAssignmentsOfMemberClients } from "@/data/repository/IresDeviceAssignmentRepository";
import { 
  viewHyDryDeviceDetailsOfMemberAccess, 
  viewPowerInformationAccess,
  viewHyDryDeviceControlAccess,
  viewHyDryDeviceDetailsOfAllClientsAccess,
  showProgramQualityRatingAccess,
  viewRunDetailsAccess,
  viewRunStartsCausedByMaxRunDurationAccess,
  viewWeatherInformationAccess,
  viewLimitLinesForRunsAccess,
  aiPredictionsAccess,
  viewProjectDetailsOfAnotherClientAccess
} from "@/permissions/UserPermissions";
import { getMinProgramChainDurationInMin } from "@/data/repository/SettingsRepository";
import { getProjectDetails, getProjectDetailsOfClient, ProjectRetrievalErrorState } from "@/data/repository/ProjectRepository";
import { 
  DEFAULT_COUNTRY_CODE, 
  getCountryCodeByCity, 
  makeGeoEncodeRequest 
} from "@/data/repository/WeatherInformationRepository";
import { GeoLocation } from "@/utils/GeocodingService";
import { WeatherInformationDetailsLevel } from "@/utils/DryingGraphYAxis";
import { calculateBackgroundStyle, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { ClientModule } from "@/store/modules/ClientModule";
import { CompanySettingsModule } from "@/store/modules/CompanySettingsModule";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { viewProgramChainsWithUndefinedProgramNumber } from "@/permissions/ClientPermissions";
import { hasCapability, DeviceCapability } from "@/data/models/DeviceCapability";
import { SensorLegendMetadata, extractSensorLegendMetadata } from "@/data/models/SensorLegendMetadata";
import { observeHyDryEventLogsOfProgramChain } from "@/data/repository/HyDryLogsRepository";
import { HyDryEventCategory } from "@/data/models/HyDryEvent";
import {
  applyCompactGraphOptions,
  getGraphAxisTitles,
  GraphAxisTitle,
  GraphSizeProfile,
  graphSizeProfileFor,
} from "@/utils/DryingGraphCompactOptions";
import { DownloadFileType, getFileTypeIcon } from "@/utils/FileTypeIcons";
import { getEffectiveUser } from "@/utils/ViewAs";

/** Space between the axis titles above the drying graph and the plot's top edge, in px. */
const AXIS_TITLES_GAP_ABOVE_PLOT = 4;
/** The overlay legend's distance from the top of the graph container, in px, until the plot has been laid out. */
const LEGEND_OVERLAY_TOP_BEFORE_LAYOUT = 20;
/** The overlay legend's own top margin (`.sensor-select` in DryingGraphLegend.vue), taken off so its box meets the plot. */
const LEGEND_OVERLAY_INNER_MARGIN = 8;

interface RunOverviewWithProjectAssignmentInfo {
  runOverview: RunOverview;
  runAssignmentInfo?: string;
}

export enum IresDeviceDetailContent {
  NONE,
  RUNS,
  DRYING,
  GRAPH,
  RATE_DRYING,
  LOG,
  PROGRAM_CHAIN_NOTES,
}

enum IresDeviceDetailScope {
  PROJECT,
  ASSIGNMENT,
  TARGET_PROGRAM_CHAIN,
  DEFAULT,
}

enum IresDeviceDetailWarning {
  NO_ACTIVE_PROGRAM_CHAIN,
  NO_PROGRAM_CHAIN_INCLUDED_IN_OPEN_ASSIGNMENT,
  NO_PROGRAM_CHAIN_INCLUDED_IN_CLOSED_ASSIGNMENT,
}

export interface ProgramChainAssignmentInfo {
  text: string;
  textClass: string;
}

export interface DryingInfoItem {
  programChain: ProgramChain;
  projectAssignmentDetails: ProjectAssignmentDetails | null;
}

@Component({
  components: {
    "panel-control": PanelControlComponent,
    "com-box-control": ComBoxControlComponent,
    "content-selector": IresDeviceDetailContentSelectorComponent,
    "panel-status-card": PanelStatusCardComponent,
    "com-box-status-card": ComBoxStatusCardComponent,
    "panel-status-entry": PanelStatusEntryComponent,
    "run-item": RunItemComponent,
    "drying-info-item": DryingInfoItemComponent,
    "drying-progress": DryingProgressGraphComponent,
    "drying-progress-control": DryingProgressGraphControlComponent,
    "drying-progress-legend": DryingProgressGraphLegendComponent,
    "infinite-loading": InfiniteLoading,
    "set-ires-device-offline": SetPanelOfflineComponent,
    "rate-drying": RateDryingComponent,
    "ai-predictions": AiPredictionsComponent,
    "reno-time-series": RenoTimeSeriesComponent,
    "drying-timeline-marker": DryingTimelineMarkerComponent,
    "hydry-log-list": HyDryEventLogListComponent,
  },
})
export default class IresDeviceDetailComponent extends Vue {
  serialNumber!: string;
  iresDeviceCategory = IresDeviceCategory.PANEL;

  statusHistory: StatusHistory[] = [];

  iresDeviceDetailScope = IresDeviceDetailScope.DEFAULT;

  subscriptions: Array<() => void> = [];

  /**
   * Set in beforeDestroy. The router view is keyed by the full URL, so a URL change during
   * created()'s first reads destroys this instance while created() is still running; its getters
   * then stay cached (iresDevice stays undefined) and anything it subscribes is never removed.
   */
  isDestroyed = false;

  lastIresDeviceUpdate: Array<IresDevice> = [];

  clientName: string | null = null;
  clientPanel: ClientPanel | null = null;

  didLoadDeviceInfo = false;

  config: PanelConfig | null = null;

  lastRefreshDate: Date = new Date();

  currentProgramChains: ProgramChain[] = [];
  runsOfCurrentProgramChains: RunOverview[] = [];

  warning: IresDeviceDetailWarning | null = null;

  programChainNumberLookup = new Map<number, number>();

  didLoadCurrentProgramChains = false;

  selectedProgramChainIndex = 0;
  lastLoadedProgramChainSerial = "";
  currentProjectAssignmentDetails: ProjectAssignmentDetails | null = null;
  contentToDisplay = IresDeviceDetailContent.GRAPH;

  canLoadMoreProgramChains = true;
  isManuallyLoadingProgramChains = false;

  showCurrentStatusOfDevice = true;

  refreshTimer!: NodeJS.Timeout;

  showingOverviewProgramChain = false;

  isLoading = false;
  isComputingGraphData = false;

  deviceNotAvailable = false;
  /** Set only once the record is known to be missing or never reported; `null` otherwise. */
  recordState: IresDeviceRecordState | null = null;

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get isAllowedToViewProgramQualityRating() {
    return showProgramQualityRatingAccess(this.activeUser);
  }

  /** When quality rating access is revoked, switch back to graph view and clear cached tab. */
  @Watch("isAllowedToViewProgramQualityRating")
  onQualityRatingAccessChanged(allowed: boolean) {
    if (!allowed && this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      this.contentToDisplay = IresDeviceDetailContent.GRAPH;
      setBoolean("KEY_OPEN_QUALITY");
    }
  }

  /**
   * Whether the current user has access to the AI Predictions view.
   * Only available for IRES admin users (VIEW_AI_PREDICTIONS in IRES_CAPABILITIES).
   */
  get isAllowedToViewAiPredictions() {
    return aiPredictionsAccess(this.activeUser);
  }

  /**
   * Show AI Predictions when it's a ComBox, user has AI predictions access,
   * and the rate-drying content is selected.
   */
  get showAiPredictions(): boolean {
    return graphPanel.showAiPredictions(this.dryingGraphVisibility);
  }

  /**
   * Show timeline markers (Stationär / Trocknen) when AI Predictions are visible
   * and a program chain is selected.
   */
  get showTimelineMarkers(): boolean {
    return graphPanel.showTimelineMarkers(this.dryingGraphVisibility);
  }

  /**
   * Whether the current prediction uses a RENO model version (R1.0+).
   * Time series is only shown for RENO models, not legacy seed models.
   */
  get isRenoModelVersion(): boolean {
    return graphPanel.isRenoModelVersion(this.selectedAiModelVersion);
  }

  /**
   * Show RENO time-series block on the main graph section for IRES users.
   * Actual visibility still depends on trend availability inside RenoTimeSeries.
   * Never for the combined view of several dryings: it is not a drying of its own, so ASSIST only
   * answered "Chain 'overview' not found" (#2610011).
   */
  get showRenoTimeSeries(): boolean {
    if (this.selectedProgramChain && isOverviewProgramChain(this.selectedProgramChain)) {
      return false;
    }
    return graphPanel.showRenoTimeSeries(this.dryingGraphVisibility);
  }

  /**
   * Snapshot of the state the drying-graph panel's visibility decisions read.
   *
   * Assembled here so the decisions themselves live in `DryingGraphPanelState`, shared with the RENO
   * review queue and unit-tested. See that module for what each flag governs.
   */
  get dryingGraphVisibility(): graphPanel.DryingGraphVisibilityInput {
    return {
      isShowingComBoxDetails: this.isShowingComBoxDetails,
      isAllowedToViewAiPredictions: this.isAllowedToViewAiPredictions,
      showRateDrying: this.showRateDrying,
      showGraph: !!this.showGraph,
      hasSelectedProgramChain: !!this.selectedProgramChain,
      predictionShowTimeline: this.predictionShowTimeline,
      selectedAiModelVersion: this.selectedAiModelVersion,
    };
  }

  /**
   * Show RateDrying for panels, or for ComBox when user doesn't have AI predictions access.
   */
  get showRateDryingSection(): boolean {
    if (!this.showRateDrying) return false;
    if (!this.isAllowedToViewProgramQualityRating) return false;
    // ComBox with AI access uses AiPredictions instead
    if (this.isShowingComBoxDetails && this.isAllowedToViewAiPredictions) return false;
    return true;
  }

  get isAllowedToViewPowerInformation() {
    return viewPowerInformationAccess(this.activeUser);
  }

  get isAllowedToViewLimitLinesForRuns() {
    return viewLimitLinesForRunsAccess(this.activeUser);
  }

  get showWeatherInformation() {
    return this.weatherInformationDetailsLevel !== WeatherInformationDetailsLevel.NONE;
  }

  get isAllowedToViewWeatherInformation() {
    return viewWeatherInformationAccess(this.activeUser) && this.showWeatherInformation;
  }

  get isAllowedToViewRunDetails() {
    return viewRunDetailsAccess(this.activeUser);
  }

  get isAllowedToViewRunStartsCausedByMaxRunDuration() {
    return viewRunStartsCausedByMaxRunDurationAccess(this.activeUser);
  }

  // ==================== FIRMWARE v4.0.0+ CHANGES ====================
  get doesSupportExtendedSensors() {
    if (this.isShowingPanelDetails) {
      return false;
    }

    return hasCapability(this.comBox, DeviceCapability.EXTENDED_SENSORS);
  }

  clientPanelAssignments: ClientPanelAssignment[] = [];
  iresDeviceAssignments: IresDeviceAssignment[] = [];

  latestDisplayedProgramChainId = "";

  targetSensors: TargetSensors = {
    showPhases: true,
    chainId: "",
    selectedCombinations: [],
  };

  isCreatingDryingReport = false;

  showPowerLine = false;
  weatherInformationDetailsLevel = WeatherInformationDetailsLevel.NONE;
  isPowerConsumptionEvaluated = false;

  legendDisplayMode = LegendDisplayMode.OVERLAY;

  showWeatherUnavailableSnackbar = false;
  isWeatherLoading = false;

  powerConsumptionValues = {
    globalMaximum: -1,
    globalMinimum: -1,
    localMaximum: [] as number[],
    localMinimum: [] as number[]
  }

  extractedDryingProgressGraphData: DryingProgressChartData | null = null;

  /** Colors to highlight in the graph when hovering a legend item. Null = no highlight. */
  legendHighlightColors: string[] | null = null;

  // Timeline marker state
  graphChartArea: { left: number; right: number; width: number; top: number } = { left: 0, right: 0, width: 0, top: 0 };
  /** The rendered height of the axis title row above the graph, in px. */
  axisTitlesAbovePlotHeight = 0;
  isGraphZoomed = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  graphVisibleRange: { xMin: number; xMax: number; startDate: Date; timeScale: any } | null = null;
  timelineStationaryValue: number | null = null;
  timelineDryValue: number | null = null;
  predictionShowTimeline = false;
  predictionHasData = false;
  lastPredictionDate: Date | null = null;
  selectedAiModelVersion = "";
  // The server's currently deployed model version, surfaced by AiPredictions.
  // Used to reset the selection to latest when leaving the Quality view.
  latestAiModelVersion = "";
  selectedAiEntry: TrendEntry | null = null;

  latitude: number | null = null;
  longitude: number | null = null;

  /**
   * The chain the weather position was last sought for, so a lookup that finds nothing is not
   * repeated for as long as the screen is open.
   *
   * Three callers ask for the position while it is missing, and two of them fire repeatedly: the
   * `iresDevice` watcher runs on every device snapshot (once a minute for a reporting ComBox) and
   * `computeDryingGraphData` on every graph recompute. Each attempt is a billed Geocoding request.
   * Keyed by chain rather than a plain flag because another chain can belong to another project,
   * and therefore to another address that deserves its own lookup.
   */
  weatherPositionAttemptedFor: string | null = null;

  /** Per-sensor metadata (serial, RSSI, battery, warnings) from event 77 logs. */
  sensorLegendMetadata: Map<number, SensorLegendMetadata> = new Map();
  sensorEventSubscription: (() => void) | null = null;

  showLoadingAnimation = false;

  get assignedClientId() {
    return this.iresDevice?.currentAssignment?.clientId;
  }

  /**
   * The message for a missing or never-reported device, or `null` for a normal one.
   * Uses the serial number from the route, because a missing device has no record to name it.
   */
  get recordStateMessage(): string | null {
    if (this.recordState === IresDeviceRecordState.MISSING) {
      return this.$t(
        this.isShowingPanelDetails
          ? "iresDeviceDetail.panelDoesNotExist"
          : "iresDeviceDetail.comBoxDoesNotExist",
        [this.serialNumber]
      ).toString();
    }

    if (this.recordState === IresDeviceRecordState.NEVER_REPORTED) {
      const createdAt = (this.iresDevice as IresDevice | undefined)?.createdAt;

      return createdAt
        ? this.$t("iresDeviceDetail.neverReportedSince", [
            this.serialNumber,
            formatDateTohDateMonthYearString(createdAt.toDate()),
          ]).toString()
        : this.$t("iresDeviceDetail.neverReported", [this.serialNumber]).toString();
    }

    return null;
  }

  /**
   * A serial number with no record. IRES, who may open any device, learn that it does not exist;
   * anyone else gets the usual "not available", which does not reveal whether the serial exists.
   */
  onIresDeviceRecordMissing() {
    if (this.didLoadDeviceInfo) {
      return;
    }

    if (this.isAllowedToViewIresDeviceDetailsOfAllClients) {
      this.recordState = IresDeviceRecordState.MISSING;
    } else {
      this.deviceNotAvailable = true;
    }

    this.showLoadingAnimation = false;
  }

  get isAllowedToViewIresDeviceDetailsOfAllClients() {
    return viewHyDryDeviceDetailsOfAllClientsAccess(this.activeUser);
  }

  get isAllowedToViewIresDeviceDetailsOfMemberClients() {
    return viewHyDryDeviceDetailsOfMemberAccess(this.activeUser) && this.isMemberClient;
  }

  get isAllowedToViewProgramChainsWithUndefinedProgramNumber() {
    return viewProgramChainsWithUndefinedProgramNumber();
  }

  get isMemberClient() {
    return this.assignedClientId ? this.memberClientIds.includes(this.assignedClientId) : false;
  }

  get memberClientIds() {
    return getMemberClientIds();
  }

  @Ref("setIresDeviceOffline")
  setIresDeviceOffline!: SetPanelOfflineComponent;

  @Ref("rateDrying")
  rateDrying!: RateDryingComponent;

  @Ref("aiPredictions")
  aiPredictions!: AiPredictionsComponent;

  @Watch("selectedProgramChainIndex")
  onSelectedProgramChainIndexChanged() {
    if (this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      this.contentToDisplay = IresDeviceDetailContent.GRAPH;
    }
    this.selectedAiModelVersion = "";
    this.selectedAiEntry = null;
    // Reset timeline marker values when program chain changes
    this.timelineStationaryValue = null;
    this.timelineDryValue = null;
    this.predictionShowTimeline = false;
    this.predictionHasData = false;
    this.lastPredictionDate = null;
  }

  @Watch("selectedProgramChain")
  onSelectedProgramChainChanged() {
    this.loadSensorLegendMetadata();
  }

  @Watch("showingOverviewProgramChain")
  onShowingOverviewProgramChainChanged(isShowingOverview: boolean) {
    if (!isShowingOverview) {
      return;
    }

    // Overview chain mode aggregates multiple chains and quality tab is disabled.
    // Clear persisted quality-tab intent so next navigation does not reopen here.
    setBoolean("KEY_OPEN_QUALITY");

    if (this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      this.contentToDisplay = IresDeviceDetailContent.GRAPH;
    }
  }

  @Watch("iresDevice")
  async onIresDeviceChanged() {
    if (
      this.isAllowedToViewWeatherInformation &&
      !this.latitude &&
      !this.longitude
    ) {
      await this.calculateLatLong();
    }
  }

  @Watch("ignoreIresAdminOrIresClientCheck")
  async onIgnoreIresAdminOrIresClientCheckChanged() {
    // The chains have to be read again, not just redrawn: see reloadProgramChainSamples.
    await this.reloadProgramChainSamples();
    this.computeDryingGraphData();
  }

  /**
   * Re-reads the chains on screen so their samples are decoded under the current capability state.
   *
   * Redrawing alone cannot work. The outlier filter (temperatures below 0 °C or from 60 °C up) is applied
   * while **decoding** a sample in `ProgramChainRepository.extractSampleInfo`, and that decode overwrites
   * the run's raw payload with the decoded values, so the chain held in memory no longer carries what the
   * device actually sent. Toggling the IRES capabilities therefore changed nothing on the graph until the
   * page was reloaded.
   *
   * Only what is drawn is re-read: the selected chain, or every current chain when the overview is
   * showing, since that one is aggregated from all of them. Chain documents carry their samples inline
   * and can run to megabytes, so re-reading the whole list on a toggle would be wasteful.
   *
   * The result goes back through {@link onCurrentProgramChainsLoaded}, which keeps the selected index and
   * rebuilds the derived state, so the tabs beside the graph (measured values, quality) stay consistent.
   */
  private async reloadProgramChainSamples() {
    const chains = this.currentProgramChains;

    if (chains.length === 0) {
      return;
    }

    const selectedChainId = this.showingOverviewProgramChain
      ? null
      : this.selectedProgramChain?.id;

    try {
      const reloaded = await Promise.all(
        chains.map((chain) =>
          selectedChainId && chain.id !== selectedChainId
            ? Promise.resolve(chain)
            : getProgramChain(this.serialNumber, chain.id)
        )
      );

      this.onCurrentProgramChainsLoaded(reloaded);
    } catch {
      // Keep what is on screen. The toggle then takes effect on the next snapshot or reload, which is
      // the behaviour this replaces, so a failed re-read is no worse than not trying.
    }
  }

  get ignoreIresAdminOrIresClientCheck() {
    return ClientModule.ignoreIresAdminOrIresClientCheck;
  }

  /**
   * Positions the weather lookup from one address, preferring a position that already exists.
   *
   * IRES Cloud geocodes the damage location, the branch and the company address when they are
   * written, so the position is normally there to be read. Looking it up again is a billed
   * Geocoding request for something we already store, and the stored one is the better of the
   * two: it is graded, and it may have been placed by hand. Weather is km-scale data, so every
   * confidence band satisfies it.
   *
   * @param location - one address in the fallback chain, with whatever is stored for it.
   * @returns whether this address settled the question, so no coarser address needs to be tried.
   */
  private async applyWeatherPosition(location: {
    coordinates?: GeoLocation | null;
    street?: string;
    houseNumber?: string;
    city?: string;
    zipCode?: string;
    countryCode?: string;
  }): Promise<boolean> {
    const stored = graphPanel.readStoredWeatherPosition(location.coordinates);

    if (stored) {
      this.latitude = stored.latitude;
      this.longitude = stored.longitude;

      return true;
    }

    const city = location.city;

    if (!city) {
      return false;
    }

    // A stored `null` is not taken as "this address has no position". It is meant to be Cloud's
    // tombstone, but `updateClientData` also writes one whenever a project is saved with no
    // coordinates to hand, so in production it marks plenty of addresses that resolve perfectly
    // (measured 2026-08-24: nine of nine sampled tombstoned damage locations came back ROOFTOP).
    // Until that is settled in Cloud, a tombstone is treated as "unknown" and looked up, exactly
    // as it is today.
    const countryCode = await this.setCountryCode(city, location.countryCode);

    await this.setCoordinates(
      location.street ?? "",
      location.houseNumber ?? "",
      city,
      location.zipCode ?? "",
      countryCode
    );

    return true;
  }

  async setCoordinates(
    street: string,
    houseNumber: string,
    city: string,
    zipCode: string,
    countryCode: string,
  ) {
    const coordinates = await makeGeoEncodeRequest(
      street,
      houseNumber,
      city,
      zipCode,
      countryCode
    );

    if (coordinates?.latitude && coordinates.longitude) {
      this.latitude = coordinates.latitude as number;
      this.longitude = coordinates.longitude as number;
    }
  }

  async setCountryCode(
    city?: string,
    countryCode?: string,
  ): Promise<string> {
    if (countryCode && countryCode !== "") {
      return countryCode;
    }
    else if (city && city !== "") {
      return (await getCountryCodeByCity(city)) ?? DEFAULT_COUNTRY_CODE;
    }
    
    return DEFAULT_COUNTRY_CODE;
  }

  async calculateLatLong() {
    const attemptKey = this.selectedProgramChain?.id ?? "no-chain";

    if (this.weatherPositionAttemptedFor === attemptKey) {
      return;
    }

    this.weatherPositionAttemptedFor = attemptKey;

    const selectedChainProjectId = this.selectedProgramChain?.assignedProjectDetails?.projectId
      ?? this.selectedProgramChain?.assignedProjectId;
    const projectId = selectedChainProjectId
      || this.iresDevice?.currentAssignment?.currentProjectId;
    const deviceBranch = this.iresDevice?.currentAssignment?.deviceBranch;

    const ownerClientId = this.selectedProgramChain?.assignedClientId
      ?? this.iresDevice?.currentAssignment?.clientId;
    const isOtherClient = ownerClientId != null && ownerClientId !== getClientId();
    const canViewOtherClient = isOtherClient
      && viewProjectDetailsOfAnotherClientAccess(this.activeUser);

    if (projectId) {
      const project = canViewOtherClient
        ? await getProjectDetailsOfClient(projectId, ownerClientId)
        : await getProjectDetails(projectId, true);

      if (
        project !== ProjectRetrievalErrorState.PROJECT_DOES_NOT_EXIST &&
        project !== ProjectRetrievalErrorState.PROJECT_IS_ARCHIVED
      ) {
        if (await this.applyWeatherPosition(project.clientData.damageLocationInfo)) {
          return;
        }
      }
    }
    
    if (deviceBranch) {
      let branch;

      if (canViewOtherClient) {
        const otherClient = await getClient(ownerClientId);
        branch = getBranchesOfMemberClient(otherClient)
          .find((b) => b.branchNumber.toString() === deviceBranch);
      } else {
        branch = getBranchesOfClient()
          .find((b) => b.branchNumber.toString() === deviceBranch);
      }

      if (branch && await this.applyWeatherPosition(branch)) {
        return;
      }
    }

    if (canViewOtherClient) {
      const otherClient = await getClient(ownerClientId);

      // The company address is used without its street, as it always was here: the city is what
      // the weather is asked for, and a whole company address is no better an answer for it.
      await this.applyWeatherPosition({
        coordinates: otherClient?.coordinates,
        city: otherClient?.city,
        zipCode: otherClient?.zip,
      });
    } else {
      const clientInfo = getClientInfo();

      await this.applyWeatherPosition({
        coordinates: clientInfo?.coordinates,
        city: clientInfo?.city,
        zipCode: clientInfo?.zipCode,
      });
    }

    return;
  }

  get hasNoProgramChainIncludedInOpenAssignment() {
    return (
      this.warning ===
      IresDeviceDetailWarning.NO_PROGRAM_CHAIN_INCLUDED_IN_OPEN_ASSIGNMENT
    );
  }

  get hasNoProgramChainIncludedInClosedAssignment() {
    if (this.filteredProgramChains.length === 0) {
      return true;
    }

    return (
      this.warning ===
      IresDeviceDetailWarning.NO_PROGRAM_CHAIN_INCLUDED_IN_CLOSED_ASSIGNMENT
    );
  }

  get hasNoActiveProgramChainWarning() {
    return this.warning === IresDeviceDetailWarning.NO_ACTIVE_PROGRAM_CHAIN;
  }

  get showNoActiveProgramChainWarning() {
    if (!this.hasNoActiveProgramChainWarning) {
      return false;
    }

    if (
      this.selectedProgramChain &&
      !isOverviewProgramChain(this.selectedProgramChain)
    ) {
      return false;
    }

    return true;
  }

  get showNoProgramChainsIncludedInClosedAssignmentWarning() {
    return (
      this.isScopedToAssignment &&
      !!this.activeClientPanelAssignment.assignmentEndDate &&
      this.didLoadCurrentProgramChains &&
      this.currentProgramChains.length === 0
    );
  }

  get activeClientPanelAssignment() {
    return this.clientPanelAssignments[0];
  }

  get isShowingPanelDetails() {
    return this.iresDeviceCategory === IresDeviceCategory.PANEL;
  }

  get isShowingComBoxDetails() {
    return this.iresDeviceCategory === IresDeviceCategory.COMBOX;
  }

  get isCurrentlyAssignedToProject() {
    return this.currentProjectAssignmentDetails !== null;
  }

  get programChainAssignmentInfo(): ProgramChainAssignmentInfo | null {
    const currentAssignment = this.iresDevice?.currentAssignment;

    const programChain = this.selectedProgramChain;

    if (!this.didLoadCurrentProgramChains) {
      return this.createProgramChainAssignmentInfo(null);
    }

    if (currentAssignment?.clientId !== getClientId()) {
      return this.createProgramChainAssignmentInfo(this.clientName);
    }

    if (this.hasNoProgramChainIncludedInOpenAssignment) {
      if (currentAssignment.currentProjectId) {
        return this.createProgramChainAssignmentInfo(
          this.$t("iresDeviceDetail.warningCheckProjectAssignment").toString(),
          true
        );
      }

      return null;
    }

    if (this.hasNoActiveProgramChainWarning) {
      if (currentAssignment.currentProjectId) {
        return this.createProgramChainAssignmentInfo(
          this.formatCurrentProjectAssignmentInfo(currentAssignment)
        );
      }

      return null;
    }

    if (this.currentProjectAssignmentDetails) {
      const completeProjectName = formatProjectNameAndNumber(
        this.currentProjectAssignmentDetails.projectName,
        this.currentProjectAssignmentDetails.projectNumber
      );

      return this.createProgramChainAssignmentInfo(completeProjectName);
    }

    if (!programChain) {
      return null;
    }

    const assignmentDetails = getProjectAssignmentDetailsOfProgramChain(
      programChain,
      this.currentProjectAssignmentDetails
    );

    const runAssignmentInfo = formatProjectAssignmentDetails(
      this,
      assignmentDetails,
      null,
      true
    );

    if (runAssignmentInfo) {
      return this.createProgramChainAssignmentInfo(runAssignmentInfo);
    }

    if (currentAssignment) {
      return this.createProgramChainAssignmentInfo(
        this.formatCurrentProjectAssignmentInfo(currentAssignment)
      );
    }

    return this.createProgramChainAssignmentInfo(
      this.$t("panelDetail.runInfo.runNoProject").toString()
    );
  }

  get isIresDeviceAssignedToClient() {
    const clientId = getClientId();

    return this.assignedClientId === clientId ||
      this.iresDeviceAssignments.find((assignment) => assignment.clientId === clientId) ||
      this.isAllowedToViewIresDeviceDetailsOfMemberClients;
  }

  get isIresDeviceCurrentlyAssignedToThisClient() {
    const clientId = getClientId();

    return this.iresDevice?.currentAssignment?.clientId === clientId;
  }

  get isAllowedToViewIresDeviceControl() {    
    return viewHyDryDeviceControlAccess(this.activeUser);
  }

  /** Creating a drying report stores a file: not while "Sicht auf" is active (ticket 2610051). */
  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  get showIresDeviceControl() {
    // Device commands are never sent while "Sicht auf" is active (ticket 2610051).
    if (!this.iresDevice || this.isViewAsReadOnly) {
      return false;
    }

    if (!this.isIresDeviceAssignedToClient && !this.isAllowedToViewIresDeviceControl) {
      return false;
    }

    return this.showCurrentStatusOfDevice;
  }

  get isScopedToAssignment() {
    return this.iresDeviceDetailScope === IresDeviceDetailScope.ASSIGNMENT;
  }

  get isScopedToProject() {
    return (
      this.iresDeviceDetailScope === IresDeviceDetailScope.PROJECT ||
      this.iresDeviceDetailScope === IresDeviceDetailScope.ASSIGNMENT
    );
  }

  get isScopedToTargetProgramChain() {
    return (
      this.iresDeviceDetailScope === IresDeviceDetailScope.TARGET_PROGRAM_CHAIN
    );
  }

  get overviewProgramChain() {
    if (!this.isScopedToProject) {
      return null;
    }

    const currentProgramChains = this.currentProgramChains;

    if (currentProgramChains.length < 2) {
      return null;
    }

    return createOverviewProgramChain(currentProgramChains);
  }

  get showOverviewChainOption() {
    return this.overviewProgramChain != null;
  }

  get panelStatusCardClass() {
    return this.showRuns ? "panel-status-card-sticky" : "";
  }

  get runs() {
    const runs = setProjectAssignmentInfoOfRuns(
      this,
      this.programChains,
      this.runsOfCurrentProgramChains,
      this.currentProjectAssignmentDetails
    );

    return runs;
  }

  get selectedProgramChainDryingInfo() {
    const selectedProgramChain = this.selectedProgramChain;

    if (!selectedProgramChain) {
      return null;
    }

    const dryingInfoItems = this.dryingInfoItems;

    if (isOverviewProgramChain(selectedProgramChain)) {
      const currentProgramChains = this.currentProgramChains;

      return dryingInfoItems.filter((info) =>
        currentProgramChains.some(
          (programChain) => programChain.id === info.programChain.id
        )
      );
    }

    const dryingInfoOfSelectedProgramChain = dryingInfoItems.find(
      (info) => info.programChain.id === selectedProgramChain.id
    );

    if (!dryingInfoOfSelectedProgramChain) {
      return null;
    }

    return [dryingInfoOfSelectedProgramChain];
  }

  get dryingInfoItems(): DryingInfoItem[] {
    return this.filteredProgramChains.map((programChain) => {
      const projectAssignmentDetailsOfProgramChain = getProjectAssignmentDetailsOfProgramChain(
        programChain,
        this.currentProjectAssignmentDetails
      );

      const assignmentInfo = 
        projectAssignmentDetailsOfProgramChain ?? getProjectAssignmentDetailsFromClientPanelAssignments(
          programChain.assignmentId,
          this.clientPanelAssignments
        );

      return {
        programChain: programChain,
        projectAssignmentDetails: assignmentInfo,
      };
    });
  }

  get filteredProgramChains(): ProgramChain[] {
    const minProgramChainDuration = getMinProgramChainDurationInMin();

    return this.currentProgramChains.filter(
      (programChain, index) =>
        (
          index === 0 ||
          matchesMinProgramChainDuration(programChain, minProgramChainDuration)
        ) &&
        (
          filterRunsWithCorrectProgramNumber(programChain) ||
          this.isAllowedToViewProgramChainsWithUndefinedProgramNumber
        ) 
    );
  }

  get programChains(): ProgramChain[] {
    const programChains = this.filteredProgramChains;

    if (
      this.isShowingComBoxDetails &&
      this.iresDevice &&
      !isPoweredOff(this.iresDevice) &&
      !this.activeClientPanelAssignment?.assignmentEndDate
    ) {
      const comBox = this.iresDevice as ComBox;
      const latestProgramChain = programChains[0];
      const ipuState = getComBoxState(comBox);

      if (
        ipuState === ComBoxDeviceState.IDLE ||
        (latestProgramChain &&
          isWaitingForNewProgramChain(comBox, latestProgramChain))
      ) {
        return [
          createNewDryRunProgramChain(this.serialNumber),
          ...programChains,
        ];
      } else {
        return programChains;
      }
    } else {
      return programChains;
    }
  }

  get selectedProgramChain(): ProgramChain | null {
    if (this.overviewProgramChain && this.showingOverviewProgramChain) {
      return this.overviewProgramChain;
    }

    return this.currentProgramChains[this.selectedProgramChainIndex];
  }

  get isShowingActiveProgramChainOfIresDevice() {
    if (this.showingNewDryingRunProgramChain) {
      return true;
    }

    const programChain = this.selectedProgramChain;

    if (!programChain) {
      return false;
    }

    let result = isActiveProgramChainOfIresDevice(
      this.iresDevice,
      programChain
    );

    if (this.showingOverviewProgramChain) {
      result = this.programChains.some((chain) =>
        isActiveProgramChainOfIresDevice(this.iresDevice, chain)
      );
    }

    return result;
  }

  get dryingProgressChartData() {
    const programChain = this.selectedProgramChain;

    if (!programChain) {
      return null;
    }

    if (programChain.id !== this.targetSensors.chainId) {
      return null;
    }
    
    const data = this.extractedDryingProgressGraphData;

    if (data?.powerConsumptionValues) {
      this.powerConsumptionValues = data.powerConsumptionValues;
      this.isPowerConsumptionEvaluated = true;
    }
    
    this.latestDisplayedProgramChainId = programChain.id;

    return data;
  }

  get showRuns() {
    return this.contentToDisplay === IresDeviceDetailContent.RUNS;
  }

  get showRateDrying() {
    return this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING;
  }

  get showLog() {
    if (this.contentToDisplay !== IresDeviceDetailContent.LOG) {
      return false;
    }

    if (!this.iresDevice) {
      return false;
    }

    if (!this.selectedProgramChain) {
      return false;
    }

    return true;
  }

  get showGraph() {
    return (
      this.selectedProgramChain &&
      (this.contentToDisplay === IresDeviceDetailContent.GRAPH ||
        this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING)
    );
  }

  /**
   * Whether to show the drying info table (Messwerte) below the graph.
   * Hidden while the Runs or Logs tab is active, where only the runs list
   * or log list should be displayed.
   */
  get showDryingInfo() {
    return (
      !!this.selectedProgramChainDryingInfo &&
      !this.showRuns &&
      !this.showLog
    );
  }

  get showLatestIresDeviceInfo() {
    if (this.isScopedToTargetProgramChain) {
      return false;
    }

    return (
      this.selectedProgramChainIndex === 0 && this.showCurrentStatusOfDevice
    );
  }

  get panel(): Panel {
    return this.iresDevice as Panel;
  }

  get comBox(): ComBox {
    return this.iresDevice as ComBox;
  }

  get iresDevice(): IresDevice {
    return this.lastIresDeviceUpdate[0];
  }

  get showComBoxStatus() {
    return (
      this.iresDeviceCategory == IresDeviceCategory.COMBOX &&
      this.didLoadDeviceInfo
    );
  }

  get showDeviceStatus() {
    if (!this.didLoadCurrentProgramChains) {
      return false;
    }

    if (this.isScopedToTargetProgramChain) {
      return false;
    }

    if (this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      return false;
    }

    if (
      this.isScopedToAssignment &&
      this.activeClientPanelAssignment.assignmentEndDate
    ) {
      return false;
    }

    return true;
  }

  get showPanelStatus() {
    return (
      this.iresDeviceCategory == IresDeviceCategory.PANEL &&
      this.didLoadDeviceInfo
    );
  }

  get companySettings() {
    return CompanySettingsModule.companySettings;
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get projectManagerSettings() {
    return this.projectManagementSettings.projectManagerSettings;
  }

  get preferAbsHumidity() {
    if (this.companySettings.preferAbsHumidity !== undefined) {
      return this.companySettings.preferAbsHumidity;
    }

    if (this.projectManagerSettings?.preferAbsHumidity !== undefined) {
      return this.projectManagerSettings.preferAbsHumidity;
    }

    return true;
  }

  get dryingGraphLegendClass(): string {
    if (this.isLegendBelow) {
      return "drying-graph-legend-below mt-2";
    }

    return "drying-graph-legend";
  }

  /**
   * Below the graph when chosen, and on phones also in place of the overlay, which would cover half
   * of the narrow plot. Hiding the legend still works there.
   */
  get isLegendBelow(): boolean {
    return (
      this.legendDisplayMode === LegendDisplayMode.BELOW ||
      (this.$vuetify.breakpoint.smAndDown && this.legendDisplayMode === LegendDisplayMode.OVERLAY)
    );
  }

  /** The drying report is a PDF, so its phone icon is the PDF file-type icon. */
  dryingReportIcon = getFileTypeIcon(DownloadFileType.PDF);

  /**
   * Phones and iPads (below 1264 px): Historie and the drying report as icons in the drying header,
   * and the view buttons on a line of their own (#2610011).
   */
  get isCompactHeader() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  /** The graph's axes and height per screen size: phones, iPad mini (600-959 px), iPad Pro (960-1263 px), desktop. */
  get graphSizeProfile(): GraphSizeProfile {
    return graphSizeProfileFor(this.$vuetify.breakpoint);
  }

  /** Lower below desktop (Taimoor, 2026-10-06): 400 px made the graph taller than a phone is wide. */
  get graphHeight(): number {
    return this.graphSizeProfile.height;
  }

  /** The graph's options, with the screen size's axes (`applyCompactGraphOptions`). */
  get graphOptions() {
    const options = this.dryingProgressChartData?.options;

    return options ? applyCompactGraphOptions(options, this.graphSizeProfile) : options;
  }

  /** The y-axis titles, shown above the plot instead of as its top tick, so the plot gets the width. */
  get axisTitlesAbovePlot() {
    const options = this.graphSizeProfile.titlesAbovePlot ? this.dryingProgressChartData?.options : null;

    return getGraphAxisTitles(options);
  }

  get hasAxisTitlesAbovePlot() {
    return this.axisTitlesAbovePlot.left.length > 0 || this.axisTitlesAbovePlot.right.length > 0;
  }

  /**
   * A title in its axis's colour and at the size its tick labels are drawn (the profile's, else the
   * axis's own), so it reads like the title tick it replaces (Taimoor, 2026-10-06).
   */
  getAxisTitleStyle(title: GraphAxisTitle) {
    const fontSize = this.graphSizeProfile.tickFontSize ?? title.fontSize;

    return { color: title.color, fontSize: fontSize ? `${fontSize}px` : undefined };
  }

  /**
   * Pulls the titles down into the room Chart.js keeps above the plot for the top tick, which is
   * blank now that its title sits up here: otherwise a tick's height of nothing parts the titles
   * from the plot (Taimoor, 2026-10-07).
   */
  get axisTitlesAbovePlotStyle(): Record<string, string> {
    return { marginBottom: `-${this.axisTitlesPulledIntoPlot}px` };
  }

  /** How far the titles above the plot are pulled down, and so the plot up. */
  get axisTitlesPulledIntoPlot(): number {
    return Math.max(0, this.graphChartArea.top - AXIS_TITLES_GAP_ABOVE_PLOT);
  }

  /** The overlay legend's top on the plot's top edge (Taimoor, 2026-10-07). */
  get legendStyle(): Record<string, string> {
    if (this.isLegendBelow) {
      return {};
    }

    if (this.graphChartArea.top === 0) {
      return { top: `${LEGEND_OVERLAY_TOP_BEFORE_LAYOUT}px` };
    }

    const titlesBottom = this.hasAxisTitlesAbovePlot ? this.axisTitlesAbovePlotHeight - this.axisTitlesPulledIntoPlot : 0;
    return { top: `${titlesBottom + this.graphChartArea.top - LEGEND_OVERLAY_INNER_MARGIN}px` };
  }

  get showingNewDryingRunProgramChain() {
    return (
      this.selectedProgramChain &&
      isNewDryRunProgramChain(this.selectedProgramChain)
    );
  }

  get showRelativeChainNumber() {
    return (
      this.isScopedToProject && !this.hasNoProgramChainIncludedInOpenAssignment
    );
  }

  get showDryingHistory() {
    if (router.currentRoute.query["projectId"]) {
      return false;
    }

    if (this.isScopedToTargetProgramChain) {
      return false;
    }

    return true;
  }

  get targetProgramChainDescription() {
    return this.$t("dryingHistory.formatDryingHistoryWithChainNumber", [
      this.$t(
        `dryingHistory.formatDryingHistory${
          this.iresDeviceCategory === IresDeviceCategory.COMBOX
            ? "Box"
            : "Panel"
        }`,
        [getIresDeviceDisplayName(this.iresDevice)]
      ),
      this.selectedProgramChain?.chainNumber ?? 0,
    ]).toString();
  }

  get selectedProgramChainDescription() {
    if (!this.programChains || !this.selectedProgramChain) {
      return this.$t("panelDetail.drying").toString();
    }

    if (this.showingNewDryingRunProgramChain) {
      return this.$t("panelDetail.dryingProgressGraphControl.formatDrying", [
        this.$t("common.new"),
      ]).toString();
    }

    if (this.showingOverviewProgramChain) {
      return this.$tc(
        "panelDetail.numDryings",
        this.currentProgramChains.length
      );
    }

    if (this.showRelativeChainNumber) {
      const relativeChainNumber = this.programChainNumberLookup.get(
        this.selectedProgramChain.chainNumber
      );

      return this.$t("dryingInfo.formatRelativeChainNumber", [
        relativeChainNumber,
      ]).toString();
    }

    const absoluteChainNumber = this.selectedProgramChain.chainNumber;

    return this.$t("panelDetail.dryingProgressGraphControl.formatDrying", [
      absoluteChainNumber,
    ]).toString();
  }

  get showSetIresDeviceOfflineButton() {
    if (!this.iresDevice) {
      return false;
    }

    const programChain = this.selectedProgramChain;

    if (!programChain) {
      return false;
    }

    const latestRun = programChain.runs[programChain.runs.length - 1];

    if (!latestRun || !isActiveRun(latestRun)) {
      return false;
    }

    return didIresDeviceTimeOut(this.iresDevice, true);
  }

  /**
   * Pre-fetches weather data in the background so it is cached when the user
   * enables the weather overlay. Runs fire-and-forget; errors are silently ignored.
   */
  private startWeatherPrefetch() {
    if (!viewWeatherInformationAccess(this.activeUser)) return;

    const programChain = this.selectedProgramChain;
    if (!programChain?.runs?.length) return;

    // Geocode if we don't have coordinates yet
    const geocodeAndPrefetch = async () => {
      if (!this.latitude || !this.longitude) {
        await this.calculateLatLong();
      }
      if (!this.latitude || !this.longitude) return;

      const runs = programChain.runs;
      const startDate = runs[0]?.startDate?.toDate() ?? new Date();
      const lastRun = runs[runs.length - 1];
      const endDate = this.isShowingActiveProgramChainOfIresDevice
        ? this.lastRefreshDate
        : (lastRun?.endDate?.toDate() ?? new Date());

      // Match the same normalization applied by extractDryingProgressGraphData
      startDate.setSeconds(0);
      startDate.setMilliseconds(0);
      endDate.setSeconds(0);
      endDate.setMilliseconds(0);

      await prefetchWeatherData(startDate, endDate, this.latitude, this.longitude);
    };

    geocodeAndPrefetch().catch(() => { /* best-effort */ });
  }

  async computeDryingGraphData(showLoadingAnimation = true) {
    this.isComputingGraphData = showLoadingAnimation;
    const programChain = this.selectedProgramChain;
    
    if (programChain && programChain.id === this.targetSensors.chainId) {
      if (
        graphPanel.needsCoordinateLookup(
          this.isAllowedToViewWeatherInformation,
          this.latitude,
          this.longitude
        )
      ) {
        await this.calculateLatLong();
      }

      // If weather was requested but coordinates are unavailable, reset and notify
      if (
        graphPanel.mustAbandonWeather(
          this.weatherInformationDetailsLevel,
          this.latitude,
          this.longitude
        )
      ) {
        this.weatherInformationDetailsLevel = WeatherInformationDetailsLevel.NONE;
        this.showWeatherUnavailableSnackbar = true;
      }

      const graphExtras = graphPanel.resolveDryingGraphExtras({
        showPowerLine: this.showPowerLine,
        isAllowedToViewPowerInformation: this.isAllowedToViewPowerInformation,
        isAllowedToViewWeatherInformation: this.isAllowedToViewWeatherInformation,
        latitude: this.latitude,
        longitude: this.longitude,
        weatherInformationDetailsLevel: this.weatherInformationDetailsLevel,
      });

      this.extractedDryingProgressGraphData = await extractDryingProgressGraphData(
        this,
        this.iresDevice,
        programChain.runs,
        this.targetSensors.selectedCombinations,
        graphPanel.buildDryingGraphOptions({
          isShowingActiveProgramChain: this.isShowingActiveProgramChainOfIresDevice,
          lastRefreshDate: this.lastRefreshDate,
          latestDisplayedProgramChainId: this.latestDisplayedProgramChainId,
          programChainId: programChain.id,
          showingOverviewProgramChain: this.showingOverviewProgramChain,
          targetSensors: this.targetSensors,
          isAllowedToViewRunStartsCausedByMaxRunDuration:
            this.isAllowedToViewRunStartsCausedByMaxRunDuration,
        }),
        this.statusHistory ?? [],
        graphExtras.showPowerLine,
        graphExtras.latitude,
        graphExtras.longitude,
        graphExtras.weatherInformationDetailsLevel,
        this.isAllowedToViewLimitLinesForRuns,
        this.isShowingActiveProgramChainOfIresDevice,
      );

      if (this.extractedDryingProgressGraphData?.weatherDataLoadFailed) {
        this.weatherInformationDetailsLevel = WeatherInformationDetailsLevel.NONE;
        this.showWeatherUnavailableSnackbar = true;
      }
    }
    this.isComputingGraphData = false;
    this.isWeatherLoading = false;
  }

  async created() {
    this.showLoadingAnimation = true;

    this.serialNumber = router.currentRoute.query["serialNumber"] as string;
    this.iresDeviceAssignments = this.isAllowedToViewIresDeviceDetailsOfMemberClients
      ? await getAllAssignmentsOfMemberClients(this.serialNumber)
      : await getAllAssignmentsOfCurrentClient(this.serialNumber, getClientId());

    if (this.isDestroyed) {
      return;
    }

    //Hack to show run list if navigating back from run details.
    if (getBoolean("KEY_OPEN_RUNS")) {
      this.contentToDisplay = IresDeviceDetailContent.RUNS;
      setBoolean("KEY_OPEN_RUNS");
    } else if (getBoolean("KEY_OPEN_QUALITY")) {
      if (this.isAllowedToViewProgramQualityRating) {
        this.contentToDisplay = IresDeviceDetailContent.RATE_DRYING;
      }
      setBoolean("KEY_OPEN_QUALITY");
    }

    this.iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
      this.serialNumber
    );

    this.lastRefreshDate = new Date();

    ToolbarContentModule.setToolbarTitle(
      this.$t(
        this.isShowingPanelDetails ? "panelDetail.title" : "comBoxDetail.title",
        [this.serialNumber]
      ).toString()
    );

    if (this.isShowingPanelDetails) {
      const cachedPanel = PanelModule.cachedPanel(this.serialNumber);

      if (cachedPanel && cachedPanel.serialNo) {
        this.lastIresDeviceUpdate = [cachedPanel];
        await this.onFirstIresDeviceInfoLoaded();
      }
    } else {
      const cachedComBox = ComBoxModule.cachedComBoxes(this.serialNumber);

      if (cachedComBox && cachedComBox.serialNo) {
        this.lastIresDeviceUpdate = [cachedComBox];
        await this.onFirstIresDeviceInfoLoaded();
      }
    }

    this.currentProjectAssignmentDetails =
      (await getCurrentProjectAssignmentDetails(this.serialNumber)) ?? null;

    if (this.isDestroyed) {
      return;
    }

    await this.computeDryingGraphData(false);

    if (this.isDestroyed) {
      return;
    }

    // Pre-fetch weather data in background so it's cached when the user toggles it on
    this.startWeatherPrefetch();

    if (this.isShowingPanelDetails) {
      this.addSubscription(
        observePanel(this.serialNumber, async (panel) => {
          if (this.isDestroyed) {
            return;
          }

          const isFirstPanelInfo = !this.didLoadDeviceInfo;
          this.lastIresDeviceUpdate = [panel];

          if (isFirstPanelInfo) {
            await this.onFirstIresDeviceInfoLoaded();
          }

          this.showLoadingAnimation = false;
        }, () => this.onIresDeviceRecordMissing())
      );
    } else {
      this.addSubscription(
        observeComBox(this.serialNumber, async (comBox) => {
          if (this.isDestroyed) {
            return;
          }

          const isFirstComBoxInfo = !this.didLoadDeviceInfo;
          this.lastIresDeviceUpdate = [comBox];

          if (isFirstComBoxInfo) {
            await this.onFirstIresDeviceInfoLoaded();
          }

          this.showLoadingAnimation = false;
        }, () => this.onIresDeviceRecordMissing())
      );
    }

    setTimeout(() => {
      if (this.showLoadingAnimation) {
        this.showLoadingAnimation = false;
      }
    }, 1000);
    
  }

  chainIdToTimeStamp(chainId: string) {
    const chainIdArray = chainId.split("-");
    const dateString = chainIdArray[chainIdArray.length-1];
    const cachedStartDate = DateTime.fromFormat(dateString, "dd:MM:yyyy_HH:mm:ss", {zone: "Europe/Berlin"}).toJSDate();

    return firestore.Timestamp.fromDate(cachedStartDate);
  }

  async onFirstIresDeviceInfoLoaded() {
    // A destroyed instance (see isDestroyed) reads a stale undefined device here.
    if (this.isDestroyed || !this.iresDevice) {
      return;
    }

    const isAllowedToViewIresDeviceDetailsOfMemberClients = this.isAllowedToViewIresDeviceDetailsOfMemberClients;
    if (isAllowedToViewIresDeviceDetailsOfMemberClients && !this.currentProjectAssignmentDetails) {
      this.currentProjectAssignmentDetails =
        (await getCurrentProjectAssignmentDetails(this.serialNumber, this.assignedClientId)) ?? null;
    }

    const chainId = router.currentRoute.query["chainId"] as string;
    const projectId = router.currentRoute.query["projectId"] as string;
    const assignmentId = router.currentRoute.query["assignmentId"] as string;
    
    const isIresDeviceCurrentlyAssignedToThisClient = this.isIresDeviceCurrentlyAssignedToThisClient;

    const shouldLoadIresDevice = 
      (
        chainId ||
        projectId ||
        assignmentId
      ) ||
      isIresDeviceCurrentlyAssignedToThisClient ||
      isAllowedToViewIresDeviceDetailsOfMemberClients;

    if (
      (
        !this.isIresDeviceAssignedToClient || 
        !shouldLoadIresDevice
      ) && 
      !this.isAllowedToViewIresDeviceDetailsOfAllClients
    ) {
      this.deviceNotAvailable = true;
      return;
    }

    ToolbarContentModule.setToolbarTitle(
      this.$t(
        this.isShowingPanelDetails ? "panelDetail.title" : "comBoxDetail.title",
        [getIresDeviceDisplayName(this.iresDevice)]
      ).toString()
    );

    // A record the device never reported to has no status, assignment or drying to load, and the
    // status cards cannot render without a status. Stop here and say why instead.
    if (getIresDeviceRecordState(this.iresDevice) === IresDeviceRecordState.NEVER_REPORTED) {
      this.recordState = IresDeviceRecordState.NEVER_REPORTED;
      return;
    }

    // Also clears NEVER_REPORTED when the device reports for the first time while the page is open:
    // the observer calls back here until `didLoadDeviceInfo` is set, so the page loads normally.
    this.recordState = null;
    this.didLoadDeviceInfo = true;

    await this.observeProgramChains(this.iresDevice);

    this.clientPanel = this.isAllowedToViewIresDeviceDetailsOfMemberClients && this.assignedClientId
      ? (await getMemberClientPanel(this.serialNumber, this.assignedClientId)) ?? null
      : (await getClientPanel(this.serialNumber)) ?? null;

    if (this.showPanelStatus) {
      await this.loadConfig();
    }

    this.startRefreshTimer();

    if (
      (
        this.isAllowedToViewIresDeviceDetailsOfAllClients ||
        this.isAllowedToViewIresDeviceDetailsOfMemberClients
      ) &&
      this.assignedClientId &&
      this.assignedClientId !== getClientId()
    ) {
      const client = await getClient(this.assignedClientId);
      this.clientName = client.clientName;
    }
  }

  observeTargetProgramChain(chainId: string) {
    this.canLoadMoreProgramChains = false;
    this.iresDeviceDetailScope = IresDeviceDetailScope.TARGET_PROGRAM_CHAIN;

    this.addSubscription(
      observeProgramChain(
        this.serialNumber,
        chainId,
        (programChain: ProgramChain) => {
          this.onCurrentProgramChainsLoaded([programChain]);
          ToolbarContentModule.setToolbarTitle(
            this.targetProgramChainDescription
          );
        }
      )
    );

    this.isLoading = false;
  }

  async observeProgramChainOfProject(projectId: string) {
    this.isManuallyLoadingProgramChains = true;
    this.canLoadMoreProgramChains = false;

    if (!this.activeClientPanelAssignment) {
      this.deviceNotAvailable = true;
      return;
    }

    const hasOpenEndedAssignments = !this.activeClientPanelAssignment
      .assignmentEndDate;
    this.showCurrentStatusOfDevice = hasOpenEndedAssignments;

    const minProgramChainDuration = getMinProgramChainDurationInMin();

    let firstUpdate = true;

    const subscription = await observeProgramChainsInTimeRanges(
      this.serialNumber,
      projectId,
      this.clientPanelAssignments.map((assignment) => {
        return {
          id: assignment.id,
          startDate: assignment.assignmentStartDate,
          endDate: assignment.assignmentEndDate,
        };
      }),
      (programChains: Array<ProgramChain>) => {
        const filteredProgramChains = programChains.filter((programChain) =>
          matchesMinProgramChainDuration(programChain, minProgramChainDuration)
        );

        this.onCurrentProgramChainsLoaded(filteredProgramChains);

        //Only want to display the program chains that belong to the assignment
        this.canLoadMoreProgramChains = !this.isScopedToAssignment;

        this.isManuallyLoadingProgramChains = false;
        this.isLoading = false;

        const unassignedProgramChains = programChains.filter(
          (chain) => !chain.assignedProjectId
        );

        if (
          this.isScopedToAssignment &&
          programChains.length === 0 &&
          !hasOpenEndedAssignments
        ) {
          //If we are displaying a closed asssignment we don't want to load more data
          this.warning =
            IresDeviceDetailWarning.NO_PROGRAM_CHAIN_INCLUDED_IN_CLOSED_ASSIGNMENT;
          return;
        }

        const isOpenEndedAssignmentMissingProgramChains =
          hasOpenEndedAssignments && unassignedProgramChains.length === 0;

        if (firstUpdate) {
          firstUpdate = false;
          this.showingOverviewProgramChain = filteredProgramChains.length > 1;
        }

        if (isOpenEndedAssignmentMissingProgramChains) {
          this.observeLatestProgramChain(projectId);
          return;
        }
      }
    );

    if (subscription) {
      this.addSubscription(subscription);
    }
  }

  async checkParamsForProjectAndAssignmentTarget(iresDevice: IresDevice) {
    let projectId = router.currentRoute.query["projectId"] as string;
    const assignmentId = router.currentRoute.query["assignmentId"] as string;

    //Check if we should load target assignment
    if (projectId && assignmentId) {
      const targetAssignment = await getClientPanelAssignment(assignmentId);

      if (!targetAssignment) {
        this.deviceNotAvailable = true;
        return;
      }

      this.clientPanelAssignments = [targetAssignment];
    } else if (
      iresDevice.currentAssignment?.currentProjectId &&
      (
        iresDevice.currentAssignment.clientId === getClientId() ||
        this.isAllowedToViewIresDeviceDetailsOfMemberClients
        
      ) &&
      iresDevice.currentAssignment.currentProjectId !== ""
    ) {
      //Else if device is currently assigned to a project load the assignments of that project
      //And observe the matching program chains
      this.clientPanelAssignments = (this.isAllowedToViewIresDeviceDetailsOfMemberClients && this.assignedClientId
        ? await getMemberClientPanelAssignmentsOfProjectAndSerialNumber(
            iresDevice.currentAssignment.currentProjectId,
            iresDevice.serialNo,
            this.assignedClientId
          )
        : await getClientPanelAssignmentsOfProjectAndSerialNumber(
            iresDevice.currentAssignment.currentProjectId,
            iresDevice.serialNo
          )
      ).sort((a, b) => {
        if (!a.assignmentEndDate) {
          return -1;
        }

        if (!b.assignmentEndDate) {
          return 1;
        }

        return (
          b.assignmentStartDate.toMillis() - a.assignmentStartDate.toMillis()
        );
      });

      projectId = iresDevice.currentAssignment.currentProjectId;
    }

    if (assignmentId) {
      this.iresDeviceDetailScope = IresDeviceDetailScope.ASSIGNMENT;
    } else if (projectId) {
      this.iresDeviceDetailScope = IresDeviceDetailScope.PROJECT;
    }

    return projectId;
  }

  async observeProgramChains(iresDevice: IresDevice) {
    const chainId = router.currentRoute.query["chainId"] as string;

    if (chainId) {
      this.observeTargetProgramChain(chainId);
      if (!this.isAllowedToViewIresDeviceDetailsOfAllClients) {
        this.clientPanelAssignments = (
          this.isAllowedToViewIresDeviceDetailsOfMemberClients && this.assignedClientId
            ? (await getMemberClientPanelAllAssignments(this.iresDevice.serialNo, this.assignedClientId))
            : (await getClientPanelAllAssignments(this.iresDevice.serialNo))
        )
          .filter((assignment) => {
            return assignment.id === this.selectedProgramChain?.assignmentId;
          });
      }
      return;
    }

    const targetProjectId = await this.checkParamsForProjectAndAssignmentTarget(
      iresDevice
    );

    if (targetProjectId) {
      this.observeProgramChainOfProject(targetProjectId);
      return;
    }

    this.observeLatestProgramChain();
  }

  async observeLatestProgramChain(targetProjectId?: string) {
    const { subscription } = await observeRecentProgramChains(
      this.serialNumber,
      (programChains: ProgramChain[]) => {
        const latestProgramChain = programChains[0];

        if (targetProjectId && latestProgramChain) {
          this.warning = null;

          if (
            isActiveProgramChainOfIresDevice(
              this.iresDevice,
              latestProgramChain
            )
          ) {
            if (
              !doesAssignmentIncludeProgramChain(
                this.activeClientPanelAssignment,
                latestProgramChain
              )
            ) {
              this.warning =
                IresDeviceDetailWarning.NO_PROGRAM_CHAIN_INCLUDED_IN_OPEN_ASSIGNMENT;
            }
          } else {
            this.warning = IresDeviceDetailWarning.NO_ACTIVE_PROGRAM_CHAIN;
            this.didLoadCurrentProgramChains = true;
            return;
          }
        } else if (
          latestProgramChain &&
          !isActiveProgramChainOfIresDevice(this.iresDevice, latestProgramChain)
        ) {
          this.didLoadCurrentProgramChains = true;
          return;
        }

        this.onCurrentProgramChainsLoaded(programChains);
      }
    );

    this.addSubscription(subscription);
    this.isLoading = false;
  }

  onCurrentProgramChainsLoaded(update: Array<ProgramChain>) {
    const didSwitchSerial = this.lastLoadedProgramChainSerial !== this.serialNumber;
    this.lastLoadedProgramChainSerial = this.serialNumber;

    const previousSelectedChainId = this.selectedProgramChain?.id;

    // When opening a different device in the same detail component instance,
    // always start on the newest chain (index 0) to keep behavior aligned
    // with the overview card (which is based on the latest chain).
    if (didSwitchSerial) {
      this.selectedProgramChainIndex = 0;
      this.showingOverviewProgramChain = false;
    }

    this.currentProgramChains = update;
    this.runsOfCurrentProgramChains = update
      .flatMap((programChain) => programChain.runs)
      .sort(
        (r1: RunOverview, r2: RunOverview) =>
          r2.startDate.seconds - r1.startDate.seconds
      );

    // Keep index in bounds when switching device/assignment so we don't point
    // to a stale chain slot from the previous context.
    if (this.selectedProgramChainIndex >= this.currentProgramChains.length) {
      this.selectedProgramChainIndex = 0;
    }

    const currentSelectedChainId = this.selectedProgramChain?.id;
    if (previousSelectedChainId !== currentSelectedChainId) {
      this.selectedAiModelVersion = "";
      this.selectedAiEntry = null;
    }

    let index = update.length;

    update.forEach((programChain) => {
      this.programChainNumberLookup.set(programChain.chainNumber, index--);
    });

    this.didLoadCurrentProgramChains = true;
  }

  async loadConfig() {
    if (this.isShowingPanelDetails) {
      const panel = this.iresDevice as Panel;

      try {
        const configOnPanel = await PanelConfigModule.loadConfig(
          panel.configurationName
        );

        if (configOnPanel && getConfigForPanelType(configOnPanel, panel)) {
          this.config = configOnPanel;
        }
      } catch (error) {
        this.config = null;
      }
    }

    if (this.isShowingPanelDetails) {
      if (this.selectedProgramChain) {
        this.statusHistory = this.selectedProgramChain?.runs[this.runs.length-1]
          ? await getPanelStatusHistoryRange(
              this.serialNumber,
              this.selectedProgramChain?.runs[0].startDate,
              this.selectedProgramChain?.runs[this.runs.length-1]?.endDate,
            )
          : await getPanelStatusHistoryRangeWithoutEndDate(
              this.serialNumber,
              this.selectedProgramChain?.runs[0].startDate,
            );
      }
      else {
        const cachedPanel = PanelModule.cachedPanel(this.serialNumber);

        if (cachedPanel && cachedPanel.serialNo) {
          this.lastIresDeviceUpdate = [cachedPanel];

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const programChainData: any = cachedPanel.programChainData;
          
          if (cachedPanel.programChainData && programChainData?.latestProgramChainId && this.statusHistory.length === 0) {
            this.statusHistory = await getPanelStatusHistoryRangeWithoutEndDate(
              this.serialNumber,
              this.chainIdToTimeStamp(programChainData?.latestProgramChainId)
            );
          }
        }
      }
    }
  }

  formatCurrentProjectAssignmentInfo(deviceAssignment: DeviceAssignment) {
    const projectName = deviceAssignment.currentProjectName;

    if (projectName) {
      return projectName;
    }

    return this.$t("panelDetail.runInfo.runNoProject").toString();
  }

  createProgramChainAssignmentInfo(
    text: string | null,
    showWarning?: boolean
  ): ProgramChainAssignmentInfo | null {
    if (!text) {
      return null;
    }

    return {
      text,
      textClass: showWarning ? "red--text font-weight-bold" : "",
    };
  }

  /** Keeps a listener for beforeDestroy to remove, or removes it at once when already destroyed. */
  addSubscription(unsubscribe: () => void) {
    if (this.isDestroyed) {
      unsubscribe();
      return;
    }

    this.subscriptions.push(unsubscribe);
  }

  beforeDestroy() {
    this.isDestroyed = true;

    // Persist quality tab so the next device opens on the same tab
    if (this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      setBoolean("KEY_OPEN_QUALITY", true);
    }

    this.subscriptions.forEach((subscription) => {
      subscription();
    });
    this.sensorEventSubscription?.();

    clearInterval(this.refreshTimer);
  }

  /**
   * Subscribes to SENSOR event logs for the current chain to extract per-sensor metadata.
   *
   * Only for the running drying: sensor info is not shown for a finished one, so a chatty chain no
   * longer costs a 500-document listener just to fill a dialog nobody can open.
   */
  private loadSensorLegendMetadata() {
    this.sensorEventSubscription?.();
    this.sensorEventSubscription = null;
    this.sensorLegendMetadata = new Map();

    if (this.isDestroyed) {
      return;
    }

    const chain = this.selectedProgramChain;
    if (!chain || !this.isShowingComBoxDetails) return;
    if (!isActiveProgramChainOfIresDevice(this.iresDevice, chain)) return;

    /* newestFirst: a long drying produces thousands of sensor events (2547 on one 29-day chain),
       so the 500 has to cover the end of it. The snapshot this feeds to the SENSOR INFO dialog is
       only useful if it is the most recent one. */
    this.sensorEventSubscription = observeHyDryEventLogsOfProgramChain(
      chain,
      500,
      [HyDryEventCategory.SENSOR],
      (logs) => {
        this.sensorLegendMetadata = extractSensorLegendMetadata(logs);
      },
      undefined,
      true
    );
  }

  toggleOverviewProgramChain() {
    this.showingOverviewProgramChain = !this.showingOverviewProgramChain;
  }

  onTargetSensorsChanged(targetSensors: TargetSensors) {
    this.targetSensors = targetSensors;
    this.computeDryingGraphData();
  }

  onComBoxHumidityChanged() {
    this.computeDryingGraphData();
  }

  onShowPowerInformationChanged(showPowerLine: boolean) {
    this.showPowerLine = showPowerLine;
    this.computeDryingGraphData();
  }

  onWeatherInformationDetailsLevelChanged(weatherInformationDetailsLevel: WeatherInformationDetailsLevel) {
    this.weatherInformationDetailsLevel = weatherInformationDetailsLevel;
    if (weatherInformationDetailsLevel !== WeatherInformationDetailsLevel.NONE) {
      this.isWeatherLoading = true;
    }
    this.computeDryingGraphData();
  }

  onLegendDisplayModeChanged(mode: LegendDisplayMode) {
    this.legendDisplayMode = mode;
  }

  onLegendHover(colors: string[] | null) {
    this.legendHighlightColors = colors;
  }

  startRefreshTimer() {
    this.refreshTimer = setInterval(() => {
      this.lastRefreshDate = new Date();
    }, 60 * 1000);
  }

  onChartAreaUpdated(area: { left: number; right: number; width: number; top: number }) {
    this.graphChartArea = area;
    // Measured with the chart area, which is re-emitted whenever the title size can change (a resize).
    this.axisTitlesAbovePlotHeight = (this.$refs.axisTitlesAbovePlot as HTMLElement | undefined)?.offsetHeight ?? 0;
  }

  onZoomStateChanged(isZoomed: boolean) {
    this.isGraphZoomed = isZoomed;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onVisibleRangeChanged(range: { xMin: number; xMax: number; startDate: Date; timeScale: any } | null) {
    this.graphVisibleRange = range;
  }

  onTimelineMarkerUpdate(event: { field: "stationary" | "dry"; relativeValue: number; timestamp: firestore.Timestamp }) {
    if (event.field === "stationary") {
      this.timelineStationaryValue = event.relativeValue;
    } else {
      this.timelineDryValue = event.relativeValue;
    }
    // Forward to AI predictions component
    if (this.aiPredictions) {
      this.aiPredictions.onTimelineMarkerUpdate(event);
    }
  }

  onTimelineValuesRestored(values: { stationaryValue: number | null; dryValue: number | null }) {
    this.timelineStationaryValue = values.stationaryValue;
    this.timelineDryValue = values.dryValue;
  }

  onPredictionStateChanged(state: { showTimeline: boolean; lastPredictionDate: Date | null; hasPredictionData: boolean; latestAvailableModel?: string }) {
    this.predictionShowTimeline = state.showTimeline;
    this.lastPredictionDate = state.lastPredictionDate;
    this.predictionHasData = state.hasPredictionData;
    if (state.latestAvailableModel) {
      this.latestAiModelVersion = state.latestAvailableModel;
    }
  }

  onTimeSeriesDaySelected(payload: { date: string; dayNumber: number; entry: TrendEntry }) {
    this.selectedAiEntry = payload.entry;
  }

  onAiModelVersionChanged(version: string) {
    this.selectedAiModelVersion = version;
  }

  @Watch("showRateDrying")
  onShowRateDryingChanged(isShowing: boolean) {
    // Leaving the Quality view: reset any older model selection back to the
    // latest so the Details graph (and timeline marker) always reflect the
    // latest model, regardless of what was picked in Quality.
    if (!isShowing && this.latestAiModelVersion) {
      this.selectedAiModelVersion = this.latestAiModelVersion;
    }
  }

  async onCreateDryingReport() {
    const selectedProgramChain = this.selectedProgramChain;

    if (!selectedProgramChain) {
      return;
    }

    this.isCreatingDryingReport = true;

    const overviewProgramChain = isOverviewProgramChain(selectedProgramChain);
    const programChains = overviewProgramChain
      ? this.currentProgramChains
      : [selectedProgramChain];

    const downloadUrl = await createPdfReportForProgramChains(
      this,
      ...programChains
    );

    this.isCreatingDryingReport = false;

    if (downloadUrl) {
      window.open(downloadUrl, "_blank");
    }
  }

  async onShowDryingHistory() {
    router.push({
      path: `dryingHistory`,
      query: {
        serialNumber: this.serialNumber,
      },
    });
  }

  async onSetIresDeviceOffline() {
    const programChain = this.currentProgramChains[0];

    if (!programChain) {
      return;
    }

    await this.setIresDeviceOffline.show(this.serialNumber, programChain);
  }

  get showRatingInDryingInfo() {
    return this.contentToDisplay !== IresDeviceDetailContent.RATE_DRYING;
  }

  onDryingRatingDone(updatedProgramChain: ProgramChain | null) {
    if (updatedProgramChain) {
      const index = this.programChains.findIndex(
        (chain) => chain.id == updatedProgramChain.id
      );

      if (index >= 0) {
        const programChainsUpdate = [...this.currentProgramChains];
        programChainsUpdate[index] = updatedProgramChain;
        this.currentProgramChains = programChainsUpdate;
      }
    }

    if (this.contentToDisplay === IresDeviceDetailContent.RATE_DRYING) {
      this.contentToDisplay = IresDeviceDetailContent.GRAPH;
    }
  }

  async onCloseRateDrying() {
    if (this.showAiPredictions && this.aiPredictions) {
      const allowedToClose = await this.aiPredictions.onCloseRating();
      if (allowedToClose) {
        this.contentToDisplay = IresDeviceDetailContent.GRAPH;
      }
    } else if (this.rateDrying) {
      const allowedToCloseRating = await this.rateDrying.onCloseRating();
      if (allowedToCloseRating) {
        this.contentToDisplay = IresDeviceDetailContent.GRAPH;
      }
    } else {
      this.contentToDisplay = IresDeviceDetailContent.GRAPH;
    }
  }

  calculateBackgroundStyle(runId: string) {
    return calculateBackgroundStyle(runId, StorageKeyLastVisitedItemLevel.LEVEL_5);
  }
}
